export default {
  base: {
    borderColor: 'black',
    backgroundColor: 'grey-05',
    borderWidth: '2px',
    p: '16px',
    '&._spark_input_empty': {
      backgroundColor: 'grey-0',
      borderColor: 'grey-40'
    },
    '::placeholder': {
      color: 'grey-60'
    },
    '&:focus, ._force-focus &': {
      boxShadow: function boxShadow(t) {
        return "0 0 0 2px ".concat(t.colors.orange);
      },
      borderColor: 'black'
    },
    '&._spark_input_left-element': {
      paddingLeft: '48px'
    },
    '&._spark_input_right-element': {
      paddingRight: '48px'
    }
  },
  variants: {
    basic: {
      '&._spark_input_empty:not(:focus)': {
        borderWidth: '1px',
        p: '17px'
      },
      '&._spark_input_left-element._spark_input_empty:not(:focus)': {
        paddingLeft: '49px'
      },
      '&._spark_input_right-element._spark_input_empty:not(:focus)': {
        paddingRight: '49px'
      }
    },
    error: {
      boxShadow: function boxShadow(t) {
        return "0 0 0 2px ".concat(t.colors.error);
      },
      '&._spark_input_empty': {
        backgroundColor: 'grey-0',
        borderColor: 'black'
      },
      borderColor: 'black'
    },
    success: {
      boxShadow: function boxShadow(t) {
        return "0 0 0 2px ".concat(t.colors.success);
      },
      '&._spark_input_empty': {
        backgroundColor: 'grey-0',
        borderColor: 'black'
      },
      borderColor: 'black'
    }
  },
  container: {
    base: {
      color: 'black'
    }
  }
};